import React from "react";

import CanvasR3F from './components/Canvas/CanvasR3F';

function App() {
  return (
    <React.StrictMode>
      <div>
        <CanvasR3F />
      </div>
    </React.StrictMode>

  );
}

export default App;